<template>
  <div>
    <div class="page">
      <a class="home-link" href="/main">Əsas səhifəyə qayıt</a>
      <img width="100%" src="../../../assets/imgs/008.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
